import { render, staticRenderFns } from "./saleGoodsTicheng.vue?vue&type=template&id=5a452698&scoped=true&"
import script from "./saleGoodsTicheng.vue?vue&type=script&lang=js&"
export * from "./saleGoodsTicheng.vue?vue&type=script&lang=js&"
import style0 from "./saleGoodsTicheng.vue?vue&type=style&index=0&id=5a452698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a452698",
  null
  
)

export default component.exports